module.exports = __webpack_public_path__ + "static/media/try-it.b2807fd0.svg";